const reversedDate = (str) => {
  var date = new Date(str);

  return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
};
export default reversedDate;
